<template>
  <div class="trends-report-dt-popup-chart" :class="fromReport ? 'align-left' : ''" :style="chartStyle">
    <div :class="getClassName">
      <div :id="chartID"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'TrendsReportDTPopupChart',
    components: {},
    props: {
      dtData: {
        type: Object,
        required: true,
      },
      border: {
        type: Boolean,
        default: false,
      },
      fromReport: {
        type: Boolean,
        default: false,
      },
      width: {
        type: Number,
        required: false,
      },
      isGlobal: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      chartLayout: {},
      forecastDataTrace: {},
      forecastUMRDataTrace: {},
      forecastLMRDataTrace: {},
      primaryHistoricDataTrace: {},
      previousHistoricDataTrace: {},
      previousForecastDataTrace: {},
      secondaryHistoricDataTrace: {},
      traces: [],
      chartID: (Math.random() + 1).toString(36).substring(3),
      imageID: (Math.random() + 1).toString(36).substring(3),
      fontSize: 14,
      chartImage: null,
    }),
    mounted() {
      if (this.fromReport) {
        this.fontSize = 17;
      }
      if (this.width) {
        this.fontSize = 10;
      }
      this.buildChartData();
    },
    updated() {
      this.buildChartData();
    },
    computed: {
      getClassName() {
        let className = '';
        if (this.border) className += 'trends-report-dt-popup-chart__border ';
        if (this.fromReport) {
          className += 'trends-report-dt-popup-chart__from-report ';
        } else {
          className += 'trends-report-dt-popup-chart__set-dimensions ';
        }
        return className;
      },
      chartStyle() {
        if (!this.width) return;
        return {
          width: this.width + 'px',
          height: 'auto',
        };
      },
    },
    methods: {
      buildChartData() {
        let forecastData = [];
        let forecastMonthYear = [];
        let showForecastData = false;

        let primaryHistoricData = [];
        let primaryHistoricMonthYear = [];
        let showPrimaryHistoricData = false;

        let previousHistoricData = [];
        let previousHistoricMonthYear = [];
        let showPreivousHistoricData = false;

        let previousForecastData = [];
        let previousForecastMonthYear = [];
        let showPreviousForecastData = false;

        let secondaryHistoricData = [];
        let secondaryHistoricMonthYear = [];
        let showSecondaryHistoricData = false;

        for (let index = 0; index < this.dtData.ForecastData.length; index++) {
          const element = this.dtData.ForecastData[index];
          forecastMonthYear.push(new Date(element.MonthYear));
          forecastData.push(element.DataPoint);
          if (element.DataPoint.trim() != '') {
            showForecastData = true;
          }
        }

        for (
          let index = 0;
          index < this.dtData.PrimaryHistoricData.length;
          index++
        ) {
          const element = this.dtData.PrimaryHistoricData[index];
          primaryHistoricMonthYear.push(new Date(element.MonthYear));
          primaryHistoricData.push(element.DataPoint);
          if (element.DataPoint.trim() != '') {
            showPrimaryHistoricData = true;
          }
        }

        for (
          let index = 0;
          index < this.dtData.PreviousPrimaryHistoricData.length;
          index++
        ) {
          const element = this.dtData.PreviousPrimaryHistoricData[index];
          previousHistoricMonthYear.push(new Date(element.MonthYear));
          previousHistoricData.push(element.DataPoint);
          if (element.DataPoint.trim() != '') {
            showPreivousHistoricData = true;
          }
        }

        for (
          let index = 0;
          index < this.dtData.PreviousForecastData.length;
          index++
        ) {
          const element = this.dtData.PreviousForecastData[index];
          previousForecastMonthYear.push(new Date(element.MonthYear));
          previousForecastData.push(element.DataPoint);
          if (element.DataPoint.trim() != '') {
            showPreviousForecastData = true;
          }
        }

        for (
          let index = 0;
          index < this.dtData.SecondaryHistoricData.length;
          index++
        ) {
          const element = this.dtData.SecondaryHistoricData[index];
          secondaryHistoricMonthYear.push(new Date(element.MonthYear));
          secondaryHistoricData.push(element.DataPoint);
          if (element.DataPoint.trim() != '') {
            showSecondaryHistoricData = true;
          }
        }

        const hoverText = this.isGlobal ? `%{customdata:.1f}` : `%{customdata:.${this.dtData.DTDecimalPrecision}f}`;


        this.primaryHistoricDataTrace = {
          type: 'scatter',
          mode: 'lines',
          x: primaryHistoricMonthYear,
          y: primaryHistoricData,
          name: this.dtData.PrimaryMetric,
          line: {
            width: 2,
            color: '#c7c7c7',
          },
          yaxis: 'y',
          xaxis: 'x',
          visible: showPrimaryHistoricData,
          customdata: primaryHistoricData,
          hovertemplate: hoverText,
        };

        this.secondaryHistoricDataTrace = {
          type: 'bar',
          x: secondaryHistoricMonthYear,
          y: secondaryHistoricData,
          name: this.dtData.SecondaryMetric,
          marker: {
            color: '#4e79cb',
          },
          width: 2600000000,
          fillcolor: '#4e79cb',
          yaxis: 'y2',
          xaxis: 'x',
          visible: showSecondaryHistoricData,
          customdata: secondaryHistoricData,
          hovertemplate: hoverText,
        };

        this.forecastDataTrace = {
          type: 'bar',
          x: forecastMonthYear,
          y: forecastData,
          marker: {
            color: '#90afd5',
          },
          width: 2600000000,
          name: `${this.dtData.SecondaryMetric} Forecast`,
          yaxis: 'y2',
          xaxis: 'x',
          visible: showForecastData,
          customdata: forecastData,
          hovertemplate: hoverText, 
        };

        this.previousHistoricDataTrace = {
          type: 'scatter',
          mode: 'scatter',
          x: previousHistoricMonthYear,
          y: previousHistoricData,
          name: `${this.dtData.SecondaryMetric} Pre-Revision`,
          line: {
            width: 3,
            color: '#ed7d31',
          },
          yaxis: 'y2',
          xaxis: 'x',
          visible: showPreivousHistoricData,
          customdata: previousHistoricData,
          hovertemplate: hoverText,
        };

        this.previousForecastDataTrace = {
          mode: 'lines',
          x: previousForecastMonthYear,
          y: previousForecastData,
          name: `${this.dtData.SecondaryMetric} Pre-Revision Forecast`,
          line: {
            dash: 'dashdot',
            width: 3,
            color: '#ed7d31',
          },
          yaxis: 'y2',
          xaxis: 'x',
          visible: showPreviousForecastData,
          customdata: previousForecastData,
          hovertemplate: hoverText,  
        };

        this.traces = [
          this.primaryHistoricDataTrace,
          this.secondaryHistoricDataTrace,
          this.forecastDataTrace,
          this.previousHistoricDataTrace,
          this.previousForecastDataTrace,
        ];

        this.chartLayout = {
          autosize: true,
          showlegend: true,
          legend: {
            orientation: 'h',
            y: 1.1,
            x: 0.5,
            xanchor: 'center',
            yanchor: 'middle',
            valign: 'middle',
            traceorder: 'normal',
            bgcolor: 'rgba(0,0,0,0)',
            bordercolor: '#444',
            borderwidth: 0,
            font: {
              size: this.fontSize,
            },
          },
          yaxis: {
            title: this.dtData.UnitOfMeasure,
            zeroline: false,
            mirror: true,
            autotick: true,
            automargin: true,
            showgrid: false,
            showline: true,
            ticks: 'outside',
            overlaying: 'y2',
            side: 'left',
          },
          yaxis2: {
            title: this.dtData.UnitOfMeasure,
            zeroline: false,
            autotick: true,
            automargin: true,
            showgrid: false,
            showline: true,
            ticks: 'outside',
            side: 'right',
          },
          xaxis: {
            type: 'date',
            dtick: 'M12',
            ticks: 'outside',
            automargin: true,
            showgrid: false,
            showline: true,
            tickformat: '%Y',
            hoverformat: '%b %Y',
          },
          margin: {
            t: 50,
            l: 50,
            r: 50,
            b: 50,
          },
          dragmode: false,
        };

        if(this.width) {
          this.chartLayout.height = this.width / 1.10576923;
          this.chartLayout.width = this.width;
        }

        this.plotChart();
      },
      plotChart() {
        Plotly.react(this.chartID, this.traces, this.chartLayout, {
          responsive: false,
          staticPlot: false,
          scrollZoom: false,
          editable: false,
          displaylogo: false,
          displayModeBar: false,
          doubleClick: false,
        }).then((chartData) => {
          this.adjustChart();
          document.getElementById(this.chartID).on('plotly_legendclick', () => {
            return false;
          });
        });
      },
      adjustChart() {
        let layoutObject = this.getTableRanges();
        Plotly.update(this.chartID, null, layoutObject);
      },     
      getTableRanges: function () {
        let y1_min = this.dtData.MinY1;
        let y1_max = this.dtData.MaxY1;
        let y2_min = this.dtData.MinY2;
        let y2_max = this.dtData.MaxY2;

        let ticks = this.getTicks(y1_min, y1_max, y2_min, y2_max);
        if (y1_min < 0) {
          y1_min = 0;
        }
        if (y2_min < 0) {
          y2_min = 0;
        }

        let decimalPlaces;
        if (Math.floor(ticks.y1dTick) === ticks.y1dTick) {
          decimalPlaces = 0;
        } else {
          decimalPlaces = ticks.y1dTick.toString().split('.')[1]?.length || 0;
        }
        const rawY2dTick = y2_max * (ticks.y1dTick / y1_max);
        const y2dTick = parseFloat(rawY2dTick.toFixed(decimalPlaces));

        return {
          'yaxis.range': [y1_min, y1_max],
          'yaxis2.range': [y2_min, y2_max],
          'yaxis.dtick': ticks.y1dTick,
          'yaxis2.dtick': y2dTick,
          'yaxis.tickformat': 'none',
          'yaxis2.tickformat': 'none',
          'xaxis.tickfont': { size: this.fontSize },
          'yaxis.tickfont': { size: this.fontSize },
          'yaxis2.tickfont': { size: this.fontSize },
          'yaxis.title.font': { size: this.fontSize },
          'yaxis2.title.font': { size: this.fontSize },
          'yaxis.ticklabelposition': 'outside', // Default value
          'yaxis2.ticklabelposition': 'outside', // Default value
        };
      },
      getTicks: function (y1_min, y1_max, y2_min, y2_max, precision = 4) {
        const GRIDLINES = 5;

        var y1_range;
        if (y1_min < 0) {
          y1_range = y1_max - y1_min;
        } else {
          y1_range = y1_max;
        }

        y1_range = y1_range * 1000; // mult by 1000 to account for ranges < 1
        let y1_len = Math.floor(y1_range).toString().length;
        let y1_pow10_divisor = Math.pow(10, y1_len - 1);
        let y1_firstdigit = Math.floor(y1_range / y1_pow10_divisor);
        let y1_max_base = (y1_pow10_divisor * y1_firstdigit) / 1000; // div by 1000 to account for ranges < 1
        let y1_dtick = y1_max_base / GRIDLINES;
        y1_pow10_divisor = Math.pow(10, y1_len - 1) / 1000; // reset for logging purposes
        y1_range = y1_range / 1000; // range reset
        var y2_range;
        if (y2_min < 0) {
          y2_range = y2_max - y2_min;
        } else {
          y2_range = y2_max;
        }

        y2_range = y2_range * 1000; // mult by 1000 to account for ranges < 1
        let y2_len = Math.floor(y2_range).toString().length;

        let y2_pow10_divisor = Math.pow(10, y2_len - 1);
        let y2_firstdigit = Math.floor(y2_range / y2_pow10_divisor);
        let y2_max_base = (y2_pow10_divisor * y2_firstdigit) / 1000; // div by 1000 to account for ranges < 1

        let y2_dtick = y2_max_base / GRIDLINES;

        y2_pow10_divisor = Math.pow(10, y2_len - 1) / 1000; // reset for logging purposes
        y2_range = y2_range / 1000; // range reset

        /**************************************************************************/
        // Capture the highest dtick ratio as your global dtick ratio.
        //
        // All other axes will have their positive and negative ranges scaled to
        // make their dtick_ratios match the global ratio. When the ratios match,
        // the gridlines match!
        /**************************************************************************/

        var y1_dtick_ratio = y1_range / y1_dtick;
        var y2_dtick_ratio = y2_range / y2_dtick;
        var global_dtick_ratio = Math.max(y1_dtick_ratio, y2_dtick_ratio);

        /**************************************************************************/
        // Calculate Range Minimums
        //
        // 1. This is done by first finding the negative ratio for all axes:
        //     1. what percentage of the range is coming from negative values
        //     2. multiply percentage by global ratio to get the percentage of the
        //        global ratio (percentage of total gridlines) that should be shown
        //        under the zero baseline.
        //
        //     NEGATIVE RATIO == NUMBER OF GRIDLINES NEEDED FOR NEGATIVE VALUES
        //
        // 2. Capturing the highest negative ratio as the global negative ratio
        //
        // 3. Then applying the negative ratio to all of your axis minimumsto get
        //    their new proportionally scaled range minimums
        /**************************************************************************/

        var negative = false; // Are there any negative values present
        var y1_negative_ratio;
        if (y1_min < 0) {
          negative = true;
          y1_negative_ratio = Math.abs(y1_min / y1_range) * global_dtick_ratio;
        } else {
          y1_negative_ratio = 0;
        }

        var y2_negative_ratio;
        if (y2_min < 0) {
          negative = true;
          y2_negative_ratio = Math.abs(y2_min / y2_range) * global_dtick_ratio;
        } else {
          y2_negative_ratio = 0;
        }

        // Increase the ratio by 0.1 so that your range minimums are extended just
        // far enough to not cut off any part of your lowest value
        var global_negative_ratio =
          Math.max(y1_negative_ratio, y2_negative_ratio) + 0.1;

        // If any negative value is present, you must proportionally extend the
        // range minimum of all axes
        var y1_range_min;
        var y2_range_min;
        if (negative) {
          y1_range_min = global_negative_ratio * y1_dtick * -1;
          y2_range_min = global_negative_ratio * y2_dtick * -1;
        } else {
          // If no negatives, baseline is set to zero
          y1_range_min = 0;
          y2_range_min = 0;
        }

        // ************************************************************************
        // Calculate Range Maximums
        //
        // 1. This is done by first finding the positive ratio for all axes:
        //     1. what percentage of the range is coming from positive values
        //     2. multiply percentage by global ratio to get the percentage of the
        //        global ratio (percentage of total gridlines) that should be shown
        //        above the zero baseline.
        //
        //     POSITIVE RATIO == NUMBER OF GRIDLINES NEEDED FOR POSITIVE VALUES
        //
        // 2. Capturing the highest positive ratio as the global positive ratio
        //
        // 3. Then applying the positive ratio to all of your axis maximums to get
        //    their new proportionally scaled range maximums
        /**************************************************************************/

        var y1_positive_ratio =
          Math.abs(y1_max / y1_range) * global_dtick_ratio;
        var y2_positive_ratio =
          Math.abs(y2_max / y2_range) * global_dtick_ratio;
        // Increase the ratio by 0.1 so that your range maximums are extended just
        // far enough to not cut off any part of your highest value
        var global_positive_ratio =
          Math.max(y1_positive_ratio, y2_positive_ratio) + 0.1;
        var y1_range_max = global_positive_ratio * y1_dtick;
        var y2_range_max = global_positive_ratio * y2_dtick;

        // Adjust the tick values to the specified precision
        y1_dtick = parseFloat(y1_dtick.toFixed(precision));
        y2_dtick = parseFloat(y2_dtick.toFixed(precision));
        y1_range_min = parseFloat(y1_range_min.toFixed(precision));
        y1_range_max = parseFloat(y1_range_max.toFixed(precision));
        y2_range_min = parseFloat(y2_range_min.toFixed(precision));
        y2_range_max = parseFloat(y2_range_max.toFixed(precision));

        return {
          y1Range: [y1_range_min, y1_range_max],
          y1dTick: y1_dtick,
          y2Range: [y2_range_min, y2_range_max],
          y2dTick: y2_dtick,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .trends-report-dt-popup-chart {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    &__border {
      overflow: hidden;
      border-radius: 20px;
      border: 2px solid black;
    }
    &__set-dimensions {
      height: 100%;
      width: 100%;
    }
    &__from-report {
      height: unset;
      width: unset;
    }
  }
  .trends-report-dt-popup-chart.align-left {
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: center;
  }
</style>
